<template>
	<div class="profile-wrapper">
		<template v-if="user !== null">



			<template v-if="user.hasPermission">


				<div class="ss-payment-info p-1" v-loading="loading.payment">
					<payment-info :user="user" :is-viewing-own-profile="isViewingOwnProfile" @fetch="fetch" />
				</div>
				<div v-loading="loading.nameBio" class="p-1">
					<name-bio :user="user" :is-viewing-own-profile="isViewingOwnProfile" @fetch="fetch($event)" />
				</div>
				<div class="ss-contact-info p-1" v-loading="loading.contactInfo">
					<contact-info :user="user" :is-viewing-own-profile="isViewingOwnProfile" @fetch="fetch($event)" />
				</div>
				<div class="ss-account-info p-1" v-loading="loading.account">
					<account :user="user" :is-viewing-own-profile="isViewingOwnProfile" @fetch="fetch($event)" />
				</div>
				<div class="ss-notifications p-1" v-loading="loading.account">
					<notifications :user="user" :is-viewing-own-profile="isViewingOwnProfile" @fetch="fetch($event)" />
				</div>

				<div class="ss-membership">
					<membership :user="user" @fetch="fetch" />
				</div>
			</template>



		</template>

		<div v-else class="alert alert-danger ss-alert">
			<p class="mb-0">Something went wrong... we can't find this user account.</p>
		</div>
		
	</div>
</template>

<script>
  import { rest } from "@/utilities/rest.js";
  import Membership from "./Membership/index.vue";
	import NameBio from "./NameBio/index.vue";
	import ContactInfo from "./ContactInfo/index.vue"
	import Account from "./Account/index.vue";
	import PaymentInfo from "./PaymentInfo/index.vue";
	import Notifications from "./Notifications/index.vue";
	import { mapGetters, mapActions } from "vuex";

	export default {
		name: "dashboard",
		data() {
			return {

				loading: {
					nameBio: false,
					contactInfo: false,
					account: false,
					payment: false
				}

			}
		},

    components: {
      [Membership.name]: Membership,
			[NameBio.name]: NameBio,
			[ContactInfo.name]: ContactInfo,
			[Account.name]: Account,
			[PaymentInfo.name]: PaymentInfo,
			[Notifications.name]: Notifications
		},

		created() {

			
		},

		mounted() {

		},

		methods: {

			...mapActions({
				getUser: "getUser",
				getPayment: "getPayment"
			}),

			fetch(which) {
				this.loading[which] = true;
				if (which !== "payment") {
					this.getUser(window.sunstonevNext.apps.account.data.urlId).then(response => {

						setTimeout(() => {
							this.loading[which] = false;
						}, 1000);

					});
				} else {
					this.getPayment(window.sunstonevNext.apps.account.data.urlId).then(response => {
						setTimeout(() => {
							this.loading[which] = false;
						}, 1000);
					});
				}
				
				
			}

			
		},

		computed: {

			...mapGetters({
				user: "user"
			}),

			isViewingOwnProfile() {
				return window.sunstonevNext.apps.account.data.urlId === window.sunstonevNext.apps.account.data.userId;
			}

			
		}
	}
</script>

<style scoped lang="scss">
	.profile-wrapper {
		min-height: 500px;
	}
</style>